/**
 * Taklit oturumu uyarısı (#64): "X olarak oturum açtınız (yönetici: Y)" + Taklidi bitir.
 * Sabit konumda (akışın dışında) durur: kabuğun tam ekran yerleşimini kaydırmasın.
 */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UserCheck, LogOut } from 'lucide-react';
import { useAuthStore } from '@/entities/session/model/authStore';

export function ImpersonationBanner() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => (s.status === 'authenticated' ? s.user : null));
  const active = !!user?.isImpersonating;

  // Sekme başlığı da ayırt etsin: yönetici sekmeleriyle karışmasın.
  useEffect(() => {
    if (!active || !user) return;
    const mark = `[${user.userCode}] `;
    const apply = () => {
      if (!document.title.startsWith(mark))
        document.title = mark + document.title.replace(/^\[[^\]]*\] /, '');
    };
    apply();
    const titleEl = document.querySelector('title');
    const mo = titleEl ? new MutationObserver(apply) : null;
    if (titleEl) mo!.observe(titleEl, { childList: true });
    return () => mo?.disconnect();
  }, [active, user]);

  if (!active || !user) return null;
  return (
    <div
      role="status"
      data-impersonation-banner
      className="fixed bottom-3 left-1/2 z-[70] flex max-w-[calc(100vw-24px)] -translate-x-1/2 items-center gap-2 rounded-full border border-amber-500/60 bg-amber-100 py-1 pr-1 pl-3 text-xs text-amber-900 shadow-[var(--shadow)] dark:bg-amber-950 dark:text-amber-100"
    >
      <UserCheck className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate">
        {t('impersonation.banner', {
          user: user.userName || user.userCode,
          admin: user.impersonatorUserName ?? '—',
        })}
      </span>
      <button
        type="button"
        onClick={() => void useAuthStore.getState().logout('manual')}
        className="inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-600 px-2 py-0.5 font-medium text-white hover:bg-amber-700"
      >
        <LogOut className="h-3 w-3" />
        {t('impersonation.end')}
      </button>
    </div>
  );
}
